import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: "/logo.svg",
  loading: "lazy",
  width: "260",
  height: "30",
  alt: "",
  class: "h-[20px] md:h-auto"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ui_icon = _resolveComponent("ui-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            { 'justify-center': _ctx.centerLogo },
            'header-height relative z-50 flex items-center px-4 bg-white lg:px-8',
        ])
  }, [
    _createVNode(_component_router_link, {
      to: `/${_ctx.currentLocale}`,
      class: "mt-[3px] max-w-[70%] block"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["to"]),
    (!_ctx.hideMenu)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "flex items-center ml-auto h-10 text-xs font-bold uppercase",
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
        }, [
          _createTextVNode(_toDisplayString(_ctx.t('menu')) + " ", 1),
          _createVNode(_component_ui_icon, {
            name: "menu",
            class: "ml-2 text-2xl"
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}